import * as consts from 'redux/constants';
import { REQ_STATUSES } from 'redux/constants';

const initialState = {
  checkoutPage: {
    data: {},
    loading: false,
    error: ''
  },
  originalPaymentObject: null,
  selectedType: {},
  selectedCategory: null,
  selectedCurrency: null,
  requiredFields: {},
  conditionalFields: {},
  requiredFieldsLoading: false,
  pmOptions: {},
  creatingPayment: {
    loading: false
  },
  paymentAlert: {
    shown: false
  },
  authorizationStatus: REQ_STATUSES.IDLE,
  hasMerchantTriggeredSdkSubmit: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case consts.AUTHORIZE_PAYMENT_METHOD_START: {
      return {
        ...state,
        authorizationStatus: REQ_STATUSES.PENDING
      };
    }
    case consts.AUTHORIZE_PAYMENT_METHOD_SUCCESS: {
      return {
        ...state,
        authorizationStatus: REQ_STATUSES.RESOLVED
      };
    }
    case consts.AUTHORIZE_PAYMENT_METHOD_FAIL: {
      return {
        ...state,
        authorizationStatus: REQ_STATUSES.IDLE
      };
    }
    case consts.CREATE_PAYMENT_START: {
      return {
        ...state,
        creatingPayment: {
          loading: true
        }
      };
    }
    case consts.CREATE_PAYMENT_SUCCESS: {
      const {
        hosted_page_updated_fields: {
          expiration,
          status,
          is_demo: isDemo,
          complete_checkout_url
        },
        payment,
        kwp_additional_data: kwpAdditionalData,
        kwp_valitor_additional_data: kwpValitorAdditionalData
      } = action.payload;

      const originalPaymentObject = state.checkoutPage.data?.payment || null;

      return {
        ...state,
        checkoutPage: {
          ...state.checkoutPage,
          data: {
            ...state.checkoutPage.data,
            expiration,
            status,
            payment,
            complete_checkout_url,
            isDemo,
            ...(kwpAdditionalData && { kwp_additional_data: kwpAdditionalData }),
            ...(kwpValitorAdditionalData && {
              kwp_valitor_additional_data: kwpValitorAdditionalData
            })
          }
        },
        creatingPayment: {
          loading: false
        },
        originalPaymentObject
      };
    }
    case consts.CREATE_PAYMENT_FAIL: {
      return {
        ...state,
        creatingPayment: {
          loading: false
        }
      };
    }
    case consts.RESET_PAYMENT_DATA: {
      return {
        ...state,
        checkoutPage: {
          ...state.checkoutPage,
          data: {
            ...state.checkoutPage.data,
            payment: {
              ...state.originalPaymentObject
            }
          }
        }
      };
    }
    case consts.GET_CHECKOUT_PAGE_START:
      return {
        ...state,
        checkoutPage: {
          ...state.checkoutPage,
          loading: true
        }
      };
    case consts.GET_CHECKOUT_PAGE_SUCCESS:
      return {
        ...state,
        checkoutPage: {
          ...state.checkoutPage,
          loading: false,
          data: action.payload.data,
          error: ''
        }
      };
    case consts.GET_CHECKOUT_PAGE_FAIL:
      return {
        ...state,
        checkoutPage: {
          ...state.checkoutPage,
          loading: false,
          error: action.payload.error
        }
      };
    case consts.SET_SELECTED_CURRENCY:
      return { ...state, selectedCurrency: action.payload };
    case consts.SET_SELECTED_TYPE:
      return { ...state, selectedType: action.payload };
    case consts.RESET_SELECTED_TYPE:
      return { ...state, selectedType: {} };
    case consts.SET_SELECTED_CATEGORY:
      return { ...state, selectedCategory: action.payload };
    case consts.SET_REQUIRED_FIELDS:
      return { ...state, requiredFields: action.payload };
    case consts.SET_REQUIRED_FIELDS_LOADING:
      return { ...state, requiredFieldsLoading: action.payload };
    case consts.SET_CONDITIONAL_FIELDS:
      return { ...state, conditionalFields: action.payload };
    case consts.CLEAR_REQUIRED_FIELDS:
      return { ...state, requiredFields: {} };
    case consts.SET_PM_OPTIONS:
      return { ...state, pmOptions: action.payload };
    case consts.CLEAR_PM_OPTIONS:
      return { ...state, pmOptions: {} };
    case consts.DISABLE_CARD_ABSTRACTION:
      return {
        ...state,
        creatingPayment: {
          loading: false
        },
        checkoutPage: {
          ...state.checkoutPage,
          data: {
            ...state.checkoutPage.data,
            feature_flags: {
              ...state.checkoutPage.data.feature_flags,
              card_abstraction: false
            }
          }
        }
      };
    case consts.RESET_CHECKOUT_STORE:
      return {
        ...state,
        ...initialState
      };
    case consts.HAS_MERCHANT_TRIGGERED_SDK_SUBMIT:
      return {
        ...state,
        hasMerchantTriggeredSdkSubmit: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
